import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { IconButton } from '@instructure/ui-buttons';
import { Menu } from '@instructure/ui-menu';
import { IconArrowDownLine, IconArrowUpLine, IconDragHandleLine, IconMiniArrowDownLine, IconMiniArrowUpLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/es/format-message';
import keyboardClickable from '../../../../../common/util/keyboardClickable';
import { MOVE_IMMUTABLE_DATA, SIDEBAR_NAV_ID, MOVED_QUIZ_ENTRY, MOVED_IN_SIDEBAR, MOVE } from '@instructure/quiz-common';
export var DragHandle = /*#__PURE__*/function (_Component) {
  function DragHandle() {
    var _this;
    _classCallCheck(this, DragHandle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DragHandle, [].concat(args));
    _defineProperty(_this, "moveUp", function () {
      _this.moveToPosition(_this.props.quizEntry.position - 1);
      var msg = t('Question moved one space up.');
      _this.props.screenreaderNotification(msg);
    });
    _defineProperty(_this, "moveDown", function () {
      _this.moveToPosition(_this.props.quizEntry.position + 1);
      var msg = t('Question moved one space down.');
      _this.props.screenreaderNotification(msg);
    });
    _defineProperty(_this, "moveToTop", function () {
      _this.moveQuizEntry(1, '');
      var msg = t('Question moved to top of assessment.');
      _this.props.screenreaderNotification(msg);
    });
    _defineProperty(_this, "moveToBottom", function () {
      _this.moveQuizEntry(_this.props.quizEntries.size, '');
      var msg = t('Question moved to bottom of assessment.');
      _this.props.screenreaderNotification(msg);
    });
    _defineProperty(_this, "handleTriggerRef", function (node) {
      _this.triggerRef = node;
    });
    return _this;
  }
  _inherits(DragHandle, _Component);
  return _createClass(DragHandle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.conditionalFocus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.conditionalFocus();
    }
  }, {
    key: "conditionalFocus",
    value: function conditionalFocus() {
      var matchingQuizEntryId = this.props.movedQuizEntry === this.props.quizEntry.id;
      var matchingLocation = this.props.onSidebar === this.props.movedInSidebar;
      if (matchingQuizEntryId && matchingLocation) {
        this.triggerRef && this.triggerRef.focus();
        this.props.clearUI(MOVED_QUIZ_ENTRY);
        this.props.clearUI(MOVED_IN_SIDEBAR);
      }
    }
  }, {
    key: "isFirstItem",
    value: function isFirstItem() {
      return this.props.quizEntry.position === 1;
    }
  }, {
    key: "isLastItem",
    value: function isLastItem() {
      var _this$props = this.props,
        quizEntry = _this$props.quizEntry,
        quizEntries = _this$props.quizEntries;
      var numItems = quizEntry.hasStimulus ? quizEntry.getNestedEntries().size : 0;
      var position = quizEntry.position + numItems;
      return position === quizEntries.size;
    }
  }, {
    key: "handleMove",
    value: function handleMove(position, stimulusQuizEntryId) {
      var _this$props2 = this.props,
        quizEntry = _this$props2.quizEntry,
        quizId = _this$props2.quizId;
      var stimulusQuizEntryIdChanged = stimulusQuizEntryId !== quizEntry.stimulusQuizEntryId;
      var isImmutable = quizEntry.isItem ? quizEntry.getEntry().isImmutable() : false;
      if (isImmutable && stimulusQuizEntryIdChanged) {
        var uiData = Map({
          movedInSidebar: this.props.onSidebar,
          quizId: quizId,
          position: position,
          stimulusQuizEntryId: stimulusQuizEntryId,
          quizEntryId: quizEntry.id
        });
        this.props.setUI(MOVE_IMMUTABLE_DATA, uiData);
        this.props.openMoveImmutableModal();
      } else {
        this.props.setUI(MOVED_IN_SIDEBAR, this.props.onSidebar);
        this.props.moveQuizEntry(quizId, position, stimulusQuizEntryId, quizEntry.id);
      }
    }
  }, {
    key: "moveQuizEntry",
    value: function moveQuizEntry(position, stimulusQuizEntryId) {
      this.props.quizEntry.isTemporary ? this.props.moveTemporaryQuizEntry(position, stimulusQuizEntryId) : this.handleMove(position, stimulusQuizEntryId);
    }
  }, {
    key: "moveToPosition",
    value: function moveToPosition(position) {
      var quizEntry = this.props.quizEntry;
      var movingDown = position > quizEntry.position;
      var newPosition = position;
      if (movingDown && quizEntry.hasStimulus) {
        newPosition = position + quizEntry.getNestedEntries().size;
      }
      var targetQuizEntry = this.props.quizEntries.find(function (qe) {
        return qe.position === newPosition;
      });
      if (targetQuizEntry === void 0) {
        var newPos = movingDown ? this.props.quizEntries.size : 1;
        this.moveQuizEntry(newPos, '');
        return;
      }
      var inStimulus = quizEntry.isInStimulus;
      var targetInStimulus = targetQuizEntry.isInStimulus;
      var losingStimulusQuizEntryId = inStimulus && !targetInStimulus;
      var receivingStimulusQuizEntryId = !inStimulus && targetInStimulus;
      var newStimulusQuizEntryId = quizEntry.stimulusQuizEntryId;

      // Handling moving of stimulus groups:
      if (quizEntry.hasStimulus) {
        if (movingDown && targetQuizEntry.hasStimulus) {
          newPosition += targetQuizEntry.getNestedEntries().size;
        } else if (!movingDown && targetInStimulus) {
          var targetStimulusQuizEntry = this.props.quizEntries.find(function (qe) {
            return qe.id === targetQuizEntry.stimulusQuizEntryId;
          });
          newPosition = position - targetStimulusQuizEntry.getNestedEntries().size;
        }

        // This block is for handling moving of items in/out/around stimuli.
        // For example, when moving down, out of a stimulus group, you don't actually
        // want the position of the quizEntry to change, you just want to change the
        // stimulusQuizEntryId, so that it's no longer associated with the stimulus.
        // There are 4 such cases:
      } else if (targetQuizEntry.hasStimulus && !inStimulus) {
        newPosition = movingDown ? position : position + 1;
        newStimulusQuizEntryId = targetQuizEntry.id;
      } else if (targetQuizEntry.hasStimulus && inStimulus) {
        newPosition = movingDown ? position - 1 : position;
        newStimulusQuizEntryId = '';
      } else if (receivingStimulusQuizEntryId && !movingDown) {
        newPosition = position + 1;
        newStimulusQuizEntryId = targetQuizEntry.stimulusQuizEntryId;
      } else if (losingStimulusQuizEntryId && movingDown) {
        newPosition = position - 1;
        newStimulusQuizEntryId = '';
      }
      this.moveQuizEntry(newPosition, newStimulusQuizEntryId);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return /*#__PURE__*/React.createElement(IconButton
      // must be a button when disabled for the screenreader to read it properly
      // must be a div when enabled to allow dragging in firefox
      , {
        as: this.props.disabled ? 'button' : 'div',
        renderIcon: IconDragHandleLine,
        withBackground: false,
        withBorder: false,
        size: "small",
        ref: this.handleTriggerRef,
        onKeyDown: keyboardClickable,
        disabled: this.props.disabled,
        "data-automation": "sdk-drag-handle",
        cursor: "move",
        screenReaderLabel: this.props.quizEntry.generateScreenReaderText(this.props.displayPosition, MOVE)
      });
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems() {
      var menuItems = [];
      if (!this.isFirstItem()) {
        menuItems.push(/*#__PURE__*/React.createElement(Menu.Item, {
          key: "toTop",
          onSelect: this.moveToTop
        }, /*#__PURE__*/React.createElement(IconArrowUpLine, null), t('Move to Top')));
        menuItems.push(/*#__PURE__*/React.createElement(Menu.Item, {
          key: "moveUp",
          onSelect: this.moveUp
        }, /*#__PURE__*/React.createElement(IconMiniArrowUpLine, null), t('Move Up')));
      }
      if (!this.isLastItem() || this.props.quizEntry.isInStimulus) {
        menuItems.push(/*#__PURE__*/React.createElement(Menu.Item, {
          key: "moveDown",
          onSelect: this.moveDown
        }, /*#__PURE__*/React.createElement(IconMiniArrowDownLine, null), t('Move Down')));
        menuItems.push(/*#__PURE__*/React.createElement(Menu.Item, {
          key: "toBottom",
          onSelect: this.moveToBottom
        }, /*#__PURE__*/React.createElement(IconArrowDownLine, null), t('Move to Bottom')));
      }
      return menuItems;
    }
  }, {
    key: "sidebarNav",
    get: function get() {
      return document.getElementById(SIDEBAR_NAV_ID);
    }
  }, {
    key: "render",
    value: function render() {
      var menuItems = this.renderMenuItems();
      if (!this.props.disabled && menuItems.length > 0) {
        return /*#__PURE__*/React.createElement(Menu, {
          trigger: this.renderIcon(),
          onToggle: this.setFocused,
          mountNode: this.props.onSidebar ? this.sidebarNav : void 0,
          placement: this.props.onSidebar ? 'start' : void 0
        }, menuItems);
      }
      return this.renderIcon();
    }
  }]);
}(Component);
_defineProperty(DragHandle, "propTypes", {
  clearUI: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  displayPosition: PropTypes.number.isRequired,
  moveTemporaryQuizEntry: PropTypes.func.isRequired,
  moveQuizEntry: PropTypes.func.isRequired,
  movedInSidebar: PropTypes.bool,
  movedQuizEntry: PropTypes.string,
  onSidebar: PropTypes.bool,
  openMoveImmutableModal: PropTypes.func.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizId: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setUI: PropTypes.func.isRequired
});
_defineProperty(DragHandle, "defaultProps", {
  disabled: false,
  movedQuizEntry: '',
  movedInSidebar: null,
  onSidebar: false
});
export default DragHandle;